import ReactGA from 'react-ga4';

const GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GA_ID || 'G-XXXXXXXXXX';

export const initializeAnalytics = () => {
  if (GOOGLE_ANALYTICS_ID !== 'G-XXXXXXXXXX') {
    ReactGA.initialize(GOOGLE_ANALYTICS_ID);
  }
};

export const trackPageView = (path) => {
  if (GOOGLE_ANALYTICS_ID !== 'G-XXXXXXXXXX') {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

export const trackEvent = (category, action, label, value) => {
  if (GOOGLE_ANALYTICS_ID !== 'G-XXXXXXXXXX') {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  }
};

export const trackFormSubmission = (formName) => {
  trackEvent('form', 'submit', formName, 1);
};

export const trackTourSelection = (tourName) => {
  trackEvent('tour', 'select', tourName, 1);
};

export const trackDownload = (fileName) => {
  trackEvent('file', 'download', fileName, 1);
};
